import { OrderManager } from './OrderManager'
import { buildIssueStoreLoader, PLANNING_ISSUE_ORDER } from './SpecialIssue'

export const getPlanningOrder = buildIssueStoreLoader(
  PLANNING_ISSUE_ORDER,
  OrderManager,
)
export type { OrderManager }
